<!-- src/views/DashboardView.vue -->

<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">دوراتي</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!--begin::Secondary button-->
          <!--<a
            href="#"
            class="btn btn-sm fw-bold bg-body btn-color-gray-700 btn-active-color-primary"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_create_app"
            >Rollover</a
          >-->
          <!--end::Secondary button-->
          <!--begin::Primary button-->
          <!-- <a
            href="#"
            class="btn btn-sm fw-bold btn-light-success"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_new_target"
            >Add Target</a
          >-->
          <!--end::Primary button-->
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار</h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>

        <div v-if="isLoggedIn == true" class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="main-content">
            <div class="page-content">
              <!-- Page-Title -->
              <br /><br />

              <div class="page-content-wrapper">
                <div class="container-fluid">
                  <div class="row mb-5">
                    <div class="col-xl-12">
                      <div class="row mb-5">
                        <div class="col-xl-12">
                          <div id="courses-section" class="row"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end row -->
                </div>
                <!-- container-fluid -->
              </div>
              <!-- end page-content-wrapper -->
            </div>
            <!-- End Page-content -->
          </div>
          <!-- end main content-->
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure
import { clearAllAuthCookies } from "@/utils/cookieBackup";

export default {
  name: "Dashboard",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      isLoggedIn: false,
      isLoading: true,
    };
  },
  created() {
    this.getUserCourses();
  },
  methods: {
    getUserCourses() {
      if (!this.token) {
        //window.location.href = "/login";
        //return;
      }
      let headers = {
        Authorization: `Bearer ${this.token}`,
      };
      api_get("/desktop/my-courses", headers)
        .then(async (response) => {
          this.isLoading = false;

          if (response.redirected || !response.ok) {
            //alert(this.token);
            //window.location.href = "/login";
            //return;
            this.isLoggedIn = false;
            return;
          }
          this.isLoggedIn = true;
          let res = await response.json();
          await this.displayCourses(res.courses);
        })
        .catch((error) => {
          console.log(error);
          //this.logout();
        });
    },
    displayCourses(courses) {
      let coursesSection = document.getElementById("courses-section");
      if (!coursesSection) {
        console.error("Courses section element not found");
        return;
      }
      coursesSection.innerHTML = ""; // Clear the section before adding new courses

      if (!courses.length) {
        document.getElementById("no-courses-message").style.display = "block";
        return;
      }

      courses.forEach((course, index) => {
        let cobj = JSON.stringify(course).replace(/'/g, ",");
        coursesSection.innerHTML += `<div class="col-md-4 mb-2"><div class="card"><div class="card-body text-center">
      


      <div class="m-1 blog__card--thumbnail">
        <img class="rounded" src="${course.image}" alt="Course Thumbnail" />
      </div>
      <div class="media-body mt-1">
        <a href='course-details/${course.id}'><h5 class="font-size-12">${course.title}</h5></a>
        <p>${course.user.fname} ${course.user.lname}</p>
      </div>
      <button type="button" class="text-center btn btn-success waves-effect waves-light btn-sm show-course" style="" id="show-course-${index}">  عرض  <i class="fa-solid fa-arrow-left"></i>  </button>
    </div></div></div>`;
      });

      // Add event listeners for the dynamically added buttons
      courses.forEach((course, index) => {
        let button = document.getElementById(`show-course-${index}`);
        if (button) {
          button.addEventListener("click", () => this.showCourse(course));
        }
      });
    },
    showCourse(course) {
      window.location.href = "course-details?id=" + course.id;
    },

    logout() {
      api("/logout", "POST", {}, { Authorization: `Bearer ${this.token}` }, false).then(
        async (response) => {
          let res = await response.json();
          alert(this.token);
          return;
          localStorage.removeItem("access_token");
          clearAllAuthCookies();
          //window.location.href = "auth-login.html";
        }
      );
      localStorage.removeItem("access_token");
      clearAllAuthCookies();
    },
  },
};
</script>

<style scoped>
.courses-header {
  padding: 10px;
  min-height: 20px;
  background-color: #ddd;
  cursor: pointer;
}
.courses-header:hover {
  background-color: #eafff3;
}
</style>
